import { isLiquidGlassSupported } from "@-/com.npmjs.callstack__liquid-glass";
import { useUniwind } from "@-/com.npmjs.uniwind";
import { useIsOverSpaceSky } from "@-/dev.improve.haniverse.components.ui.space-backdrop";

/**
 * The wash a toolbar control's glass carries. A tinted regular material keeps toolbar controls
 * legible even over an empty white page; over the experimental space background it drops the white
 * wash so the sky reads through. A surface that grows out of a control (its menu) starts with
 * this tint, so the handoff from the control's glass to its own is invisible.
 */
export function useToolbarGlassTint(selected = false): string | undefined {
  const { theme } = useUniwind();
  const isOverSky = useIsOverSpaceSky() && isLiquidGlassSupported;
  return isOverSky
    ? selected
      ? "#FFFFFF30"
      : undefined
    : theme === "dark"
      ? selected
        ? "#FFFFFF30"
        : "#FFFFFF12"
      : selected
        ? "#FFFFFFE0"
        : "#FFFFFF80";
}
